import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=f9b592ac&scoped=true&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordModal.vue?vue&type=style&index=0&id=f9b592ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b592ac",
  null
  
)

export default component.exports